<ng-container *ngIf="awardsData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="awardsData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--smallMargin TableTitle--withLegend">
    <h2 class="Award">Awards</h2>
    <div class="Legend">
      <ul>
        <li>Proposed, Ongoing</li>
        <li>Finished, Halted</li>
      </ul>
    </div>
  </div>
  <div class="EntryPoint" *ngIf="awardsData.awards.length > 0">
    <div class="EntryPoint-header">
      <div class="EntryPoint-country">
        <h3>Country</h3>
      </div>
      <div class="EntryPoint-content">
        <div class="EntryPoint-Awards">
          <div *ngFor="let allYearGroup of awardsData.allYearGroups" class="EntryPoint-Award">
            <h3>{{ ('GroupOfYears.' + allYearGroup) | translate }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let row of awardsData.awards;" class="EntryPoint-row">
      <div class="EntryPoint-country" [class.EntryPoint-country--active]="isActiveRow(row)" (click)="toggleActiveRows(row)">
        <h2><a [routerLink]="'/awards/country/'+row.countryCode" [queryParams]="{regionCode: regionCodes}">{{ ('CountryNames.' + row.countryCode) | translate }}</a></h2>
      </div>
      <div class="EntryPoint-content">
        <div class="EntryPoint-Awards">
          <div *ngFor="let yearGroup of awardsData.allYearGroups" class="EntryPoint-Award" [class.EntryPoint-Award--empty]="isYearGroupEmpty(row,yearGroup)">
            <header>
              <h3>{{ ('GroupOfYears.' + yearGroup) | translate }}</h3>
            </header>
            <ul>
              <li *ngFor="let award of row.yearGroups[yearGroup]">
                <ng-template #tipContent>{{award.shortTitle}}</ng-template>
                <a [routerLink]="'/awards/'+award.awardKey" [queryParams]="{regionCode: regionCodes}" class="Awards" [ngClass]="award.status" [ngbTooltip]="tipContent">
                  {{ award.awardKey | delete2FirstChar }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="NoResult" *ngIf="awardsData.awards.length===0">
    <p>No award registered in the database</p>
  </div>
</ng-container>
